'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UIImage from 'UIComponents/image/UIImage';

const getImageLinkBySize = size => {
  switch (size) {
    case 'large':
    case 'lg':
      return 'https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-200px.png';

    case 'medium':
    case 'md':
      return 'https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-150px.png';

    case 'small':
    case 'sm':
      return 'https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-100px.png';

    default:
      return 'https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-100px.png';
  }
};

const PayPalLogo = ({
  size
}) => {
  const imageLink = getImageLinkBySize(size);
  return /*#__PURE__*/_jsx(UIImage, {
    src: imageLink
  });
};

PayPalLogo.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large', 'sm', 'md', 'lg'])
};
export default PayPalLogo;